type AnyFunction = (...args: any[]) => void;

type DelayedFunctionParams<F extends AnyFunction> = {
  timeout: number;
  func: F;
};

type TimeoutId = ReturnType<typeof setTimeout>;

export const throttle = <F extends AnyFunction>({ timeout, func }: DelayedFunctionParams<F>) => {
  let timeoutId: TimeoutId | null = null;

  return (...args: Parameters<F>): TimeoutId => {
    if (timeoutId !== null) {
      return timeoutId;
    }

    timeoutId = setTimeout(() => {
      func(...args);

      if (timeoutId !== null) {
        clearTimeout(timeoutId);
        timeoutId = null;
      }
    }, timeout);

    return timeoutId;
  };
};
